/**
 * Enums describing if the object has just been created, updated, deleted, or has not been modified.
 */
export enum DirtyStatus {
  UNMODIFIED = 0,
  NEW = 1,
  UPDATED = 2,
  DELETED = 3,
  PENDING = 4,
}
